








































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SpiritualSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = { agama: "", agama_lainnya: "", kegiatan_ibadah: "selalu", nilai_kepercayaan: "" };

  agamaOptions = [
    "Islam",
    "Kristen (Protestan)",
    "Katolik",
    "Hindu",
    "Buddha",
    "Konghucu",
    "Lainnya",
  ];

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
    this.normalizeAgama();
  }

  // Data lama menyimpan agama sebagai teks bebas. Bila nilainya di luar daftar
  // baku, petakan ke "Lainnya" dan simpan teks aslinya di agama_lainnya.
  normalizeAgama() {
    const val = this.form.agama;
    if (val && !this.agamaOptions.includes(val)) {
      this.form.agama_lainnya = val;
      this.form.agama = "Lainnya";
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    this.normalizeAgama();
  }
}
